/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { ScenarioNodeWithDetails } from './scenarioNodeWithDetails'
import type { ScenarioNodeWithVideoUrlAllOf } from './scenarioNodeWithVideoUrlAllOf'

export type ScenarioNodeWithVideoUrl = ScenarioNodeWithDetails & ScenarioNodeWithVideoUrlAllOf
